module.exports = __webpack_public_path__ + "static/media/elegant-color-pallete.e343dd53.png";